import { render, staticRenderFns } from "./CallCell.vue?vue&type=template&id=32781bf5&scoped=true&"
import script from "./CallCell.vue?vue&type=script&lang=js&"
export * from "./CallCell.vue?vue&type=script&lang=js&"
import style0 from "./CallCell.vue?vue&type=style&index=0&id=32781bf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32781bf5",
  null
  
)

export default component.exports